import React from 'react';
import VehicleRegistration from './components/VehicleRegistration';
import MaterialLoading from './components/MaterialLoading';
import DeliverySchedule from './components/DeliverySchedule';
import i18n from '../../../../i18n';
import '../../../../styles/components/loading-management.scss';
import CleaningSchedule from './components/CleaningSchedule';
import { getLoadingManagement } from './services/LoadingManagementService';
import { toast } from 'react-toastify';

class FleetManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'deliverySchedule', // Default fallback
            hideSidebar: false,
            loadingData: true,
            counts: {
                deliverySchedule: {
                    schedule: 0,
                    pending: 0,
                    total: 0
                },
                materialLoading: {
                    in: 0,
                    out: 0,
                    total: 0
                },
                houseKeeping: {
                    total: 0
                }
            }
        };
    }

    componentDidMount() {
        // Read tab from URL query parameter
        this.getTabFromUrl();
        this.fetchLoadingManagement();
    }

    componentDidUpdate(prevProps, prevState) {
        // Update URL when activeTab changes
        if (prevState.activeTab !== this.state.activeTab) {
            this.updateUrlWithTab(this.state.activeTab);
        }
    }

    getTabFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        const tabParam = params.get('tab');
        
        // Valid tab values
        const validTabs = ['deliverySchedule', 'vehicleRegistration', 'materialLoading', 'houseKeeping'];
        
        if (tabParam && validTabs.includes(tabParam)) {
            this.setState({ activeTab: tabParam });
        } else {
            // If no valid tab in URL, set default and update URL
            this.updateUrlWithTab('deliverySchedule');
        }
    };

    updateUrlWithTab = (tabName) => {
        const params = new URLSearchParams(window.location.search);
        params.set('tab', tabName);
        
        // Update URL without reloading the page
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState(null, '', newUrl);
    };

    handleTabChange = (tabName) => {
        this.setState({ activeTab: tabName });
        // URL update is handled in componentDidUpdate
    }

    renderActiveComponent = () => {
        const commonProps = {
            hideSidebar: this.state.hideSidebar,
        };

        switch (this.state.activeTab) {
            case 'vehicleRegistration':
                return <VehicleRegistration
                    {...commonProps}
                    onVehicleAdded={this.handleVehicleAdded}
                />;
            case 'materialLoading':
                return <MaterialLoading
                    {...commonProps}
                    onTicketCreated={this.handleTicketCreated}
                    refreshCount={this.fetchLoadingManagement}
                />;
            case 'deliverySchedule':
                return <DeliverySchedule
                    {...commonProps}
                    onScheduleUpdated={this.handleScheduleUpdated}
                    refreshCount={this.fetchLoadingManagement}
                />;
            case 'houseKeeping':
                return <CleaningSchedule
                    {...commonProps}
                    onScheduleUpdated={this.handleScheduleUpdated}
                />;
            default:
                return <DeliverySchedule {...commonProps} />;
        }
    }

    handleVehicleAdded = (vehicleData) => {
        console.log('Vehicle added:', vehicleData);
    }

    handleTicketCreated = (ticketData) => {
        console.log('Ticket created:', ticketData);
        this.fetchLoadingManagement();
    }

    handleScheduleUpdated = (scheduleData) => {
        console.log('Schedule updated:', scheduleData);
        this.fetchLoadingManagement();
    }

    fetchLoadingManagement = async () => {
        this.setState({ loadingData: true });

        try {
            const response = await getLoadingManagement();
            
            if (response.success && response.data) {
                const data = response.data;
                
                this.setState({
                    counts: {
                        deliverySchedule: {
                            schedule: data.delivery_schedule?.schedule_count || 0,
                            pending: data.delivery_schedule?.pending_count || 0,
                            completed: data.delivery_schedule?.completed_count || 0,
                            total: data.delivery_schedule?.total_count || 0
                        },
                        materialLoading: {
                            in: data.material_loading?.in_count || 0,
                            out: data.material_loading?.out_count || 0,
                            total: data.material_loading?.total_count || 0
                        },
                        houseKeeping: {
                            total: data.house_keeping?.total_count || 0
                        }
                    },
                    loadingData: false
                });
            } else {
                toast.error(response.message || 'Failed to fetch loading management data');
                this.setState({ loadingData: false });
            }
        } catch (error) {
            console.error('Error fetching loading management data:', error);
            toast.error('Error loading management counts');
            this.setState({ loadingData: false });
        }
    };

    render() {
        const { activeTab, loadingData, counts } = this.state;

        return (
            <React.Fragment>
                <section className="site-visit-details-page bg-white">
                    <div className="container">
                        <div className="row">
                            <div className='col-xl-12 col-lg-12 col-md-12'>
                                <div className="fleet-management-tabs card">
                                    {/* Cards Section */}
                                    <div className="fleet-cards-container">
                                        {/* Delivery Schedule Card */}
                                        <div
                                            className={`fleet-card ${activeTab === 'deliverySchedule' ? 'active' : ''}`}
                                            onClick={() => this.handleTabChange('deliverySchedule')}
                                        >
                                            <div className="fleet-card-title">
                                              📅  {i18n.t('delivery_schedule')}
                                            </div>
                                            <div className="fleet-card-counts">
                                                <div className="count-group">
                                                    <span className="count-badge count-badge-out">
                                                        {counts.deliverySchedule.pending}
                                                    </span>
                                                    <span className="count-label">Pending</span>
                                                </div>

                                                
                                                <div className="count-group">
                                                    <span className="count-badge count-badge-pending">
                                                        {counts.deliverySchedule.schedule}
                                                    </span>
                                                    <span className="count-label">In Transit</span>
                                                </div>

                                                <div className="count-group">
                                                    <span className="count-badge count-badge-schedule">
                                                        {counts.deliverySchedule.completed}
                                                    </span>
                                                    <span className="count-label">Completed</span>
                                                </div>
                                                
                                            </div>
                                        </div>

                                        {/* Material Loading Card */}
                                        <div
                                            className={`fleet-card ${activeTab === 'materialLoading' ? 'active' : ''}`}
                                            onClick={() => this.handleTabChange('materialLoading')}
                                        >
                                            <div className="fleet-card-title">
                                              🎫  {i18n.t('material_loading')}
                                            </div>
                                            <div className="fleet-card-counts">
                                                <div className="count-group">
                                                    <span className="count-badge count-badge-in">
                                                        {counts.materialLoading.in}
                                                    </span>
                                                    <span className="count-label">IN</span>
                                                </div>
                                                <div className="count-group">
                                                    <span className="count-badge count-badge-out">
                                                        {counts.materialLoading.out}
                                                    </span>
                                                    <span className="count-label">OUT</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* House Keeping/Cleaning Schedule Card */}
                                        <div
                                            className={`fleet-card ${activeTab === 'houseKeeping' ? 'active' : ''}`}
                                            onClick={() => this.handleTabChange('houseKeeping')}
                                        >
                                            <div className="fleet-card-title">
                                              🧹  {i18n.t('cleaning_schedule')}
                                            </div>
                                            <div className="single-count">
                                                {counts.houseKeeping.total}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Content Section */}
                                    <div>
                                        {this.renderActiveComponent()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default FleetManagement;